export const fullscreenActiveDefaultZIndex = 3900; // less than modal overlay
